import 'css-chunk:src/applications/TermsApp/components/shared/PostInstructions/PostInstructions.scss';export default {
  "PostInstructions": "_PostInstructions_y39qx_1",
  "item": "_item_y39qx_12",
  "PostInstruction": "_PostInstruction_y39qx_1",
  "PostInstructionReadOnly": "_PostInstructionReadOnly_y39qx_19"
};